import React, { useEffect, useState } from "react";
import ReactFlow, { Controls, Background } from "react-flow-renderer";
// import flowchartData from "../pages/data/dummy.json";
import "../css/flowchart.css";
import CustomInputNode from "./customInputNode";
import CustomOutputNode from "./customOutputNode";
import CustomDefaultNode from "./customDefaultNode";
import Global from "../utils/global";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

const nodeTypes = {
  _input: CustomInputNode,
  _output: CustomOutputNode,
  _default: CustomDefaultNode,
};

interface props {
   expanded: string | false;
   setExpanded: Function;
   selectedNodes: any;
   setSelectedNodes: Function;
   disease_id: String;
   setPrvDisabled: Function;
   setFlowchartId: Function;
}

const Flowchart = (props: props) => {
   const firstNodeXPosition = 100;
   let { selectedNodes, setSelectedNodes } = props;

   const [isLoading, setIsLoading] = useState(false);
   const [flowchartData, setFlowchartData]: any = useState();

   const getFlowchartData = async () => {
      setIsLoading(true);
      const data = await Global.httpGET(`disease/${props.disease_id}`);
      if (data) {
         console.log(data);
         setFlowchartData(data.flowchart.nodes);
         props.setFlowchartId(data.flowchart.id);
         setIsLoading(false);
      } else {
         setIsLoading(false);
      }
   };

   useEffect(() => {
      if (props.disease_id && !flowchartData && Global.token) {
         getFlowchartData();
      }
   }, [props.disease_id]);

   const nodeStyle = {
      width: "auto",
      minWidth: "100px",
      maxWidth: "200px",
      background: "#fff",
      border: "1px solid #1a192b",
      borderRadius: "3px",
      color: "#222",
      fontSize: "12px",
      padding: "10px",
      // textAlign: "center",
   };

   const createNodeAndEdgeForFlow = (
      nodeData: any,
      parentNode: any = "",
      leftNode: any = ""
   ) => {
      const generatePosition = () => {
         let x;
         let y;

         if (leftNode) {
            x = leftNode.position.x + 250;
            y = leftNode.position.y;
         } else if (parentNode) {
            x = parentNode.position.x;
            y = parentNode.position.y + parentNode.height + 50;
         } else {
            x = firstNodeXPosition;
            y = 50;
         }

         return { x, y };
      };

      //create node with data
      let node: any = {
         id: nodeData.id,
         type: nodeData.type,
         data: nodeData.data,
         position: generatePosition(),
         level: nodeData.level,
         style: nodeStyle,
      };

      //initialize empty edge object
      let edge;

      if (nodeData.source !== 0) { //check if this node is not the first node
         //create edge with data
         edge = {
            id: "ed-" + nodeData.id,
            source: nodeData.source,
            target: nodeData.id,
            type: "smoothstep",
            targetLevel: nodeData.level,
         };
      }
      return { node, edge };
   };

   const [nodes, setNodes]: any = useState();
   // const [nodesWOStyle, setNodesWOStyle] = useState();
   const [edges, setEdges]: any = useState();

   const edgeType = "smoothstep";
   const selNodeStyle = {
      ...nodeStyle,
      border: "1.5px solid blue",
   };

   const selEdgeStyle = { stroke: "blue" };

   let initialNodes: any = [];
   let initialEdges: any = [];
   const [maxLevel, setMaxLevel] = useState(1);

   const createInitialData = () => {
      if (initialNodes[0]) return;
      const firstNodeData = flowchartData.find((data: any) => data.level === 1);
      let firstNode = createNodeAndEdgeForFlow(firstNodeData).node;
      // firstNode = {
      //    ...firstNode,
      //    style: selNodeStyle,
      // };
      // setSelectedNodes([firstNode]);
      initialNodes.push(firstNode);
      // const secLvlNodeData = flowchartData.filter((data) => data.level === 2);
      // // console.log({ secLvlNodeData });
      // secLvlNodeData.map((data) => {
      //    let secLvlNode;
      //    if (initialNodes.length === 1) {
      //       secLvlNode = createNodeAndEdgeForFlow(data, firstNode);
      //    } else {
      //       const leftNodeIndex = initialNodes.length - 1;
      //       secLvlNode = createNodeAndEdgeForFlow(
      //          data,
      //          "",
      //          initialNodes[leftNodeIndex]
      //       );
      //    }
      //    initialNodes.push(secLvlNode.node);
      //    initialEdges.push(secLvlNode.edge);
      //    setMaxLevel(data.level);
      //    return 0;
      // });

      // console.log({ initialNodes, initialEdges });
      // setMaxLevel(firstNodeData.level);
      setNodes(initialNodes);
      setEdges(initialEdges);
   };
   useEffect(() => {
      if (flowchartData) {
         createInitialData();
      }
   }, [flowchartData]);

   // createInitialData();

   const createChildren = (parentNode: any) => {
      setSelectedNodes((latestData: any) => [...latestData, parentNode]);
      let newNodes: any = [];
      let newEdges: any = [];
      if (parentNode.type !== "_output") {
         //generate new node
         const childrens = flowchartData.filter(
            (data: any) => data.source === parentNode.id
         );
         // console.log(childrens);
         childrens.map((data: any) => {
            let nodeAndEdge;
            if (newNodes.length === 0) {
               nodeAndEdge = createNodeAndEdgeForFlow(data, parentNode);
            } else {
               const leftNode = newNodes.length - 1;
               nodeAndEdge = createNodeAndEdgeForFlow(
                  data,
                  "",
                  newNodes[leftNode]
               );
            }
            newNodes.push(nodeAndEdge.node);
            newEdges.push(nodeAndEdge.edge);
            setMaxLevel(data.level);
         });
      }

      return { nodes: newNodes, edges: newEdges };
   };

   const handleNodeClick = (e: any, selNode: any) => {
      props.setExpanded(selNode.id);
      if (selNode.level === maxLevel) {
         //check if sel node is the last node of current flowchart
         let allEdges = edges;

         const index = edges.findIndex(
            (data: any) => data.target === selNode.id
         );
         if (index >= 0) {
            let highlightedEdge = edges[index];
            allEdges.splice(index, 1);
            highlightedEdge.style = selEdgeStyle;
            allEdges = [...allEdges, highlightedEdge];
            setEdges(allEdges);
         }
         if (selNode.type !== "_output") {
            props.setPrvDisabled(true);

            //check if it is a last node
            const childrens = createChildren(selNode);
            const existingNodesWOSelNode = nodes.filter(
               (data: any) => data.id !== selNode.id
            );
            let selNodeInArray = nodes.find(
               (data: any) => data.id === selNode.id
            );
            selNodeInArray.style = selNodeStyle;

            setNodes([
               ...existingNodesWOSelNode,
               selNodeInArray,
               ...childrens.nodes,
            ]);
            setEdges([...allEdges, ...childrens.edges]);
         } else {
            //for output nodes if none of them is selected
            props.setPrvDisabled(false);
            const existingNodesWOSelNode: any = [];
            nodes.map((data: any) => {
               if (data.level < selNode.level) {
                  existingNodesWOSelNode.push(data);
               } else if (data.level === selNode.level) {
                  existingNodesWOSelNode.push({
                     id: data.id,
                     type: data.type,
                     data: data.data,
                     position: data.position,
                     level: data.level,
                     style: nodeStyle,
                  }); //added individual keys to remove style key
               }
            });
            let selNodeInArray = nodes.find(
               (data: any) => data.id === selNode.id
            ); //find current level selected node
            selNodeInArray.style = selNodeStyle;

            setSelectedNodes((latestNodes: any) => [
               ...latestNodes,
               selNodeInArray,
            ]);

            setMaxLevel(maxLevel + 1);

            setNodes([...existingNodesWOSelNode, selNodeInArray]);
         }
      } else {
         if (selNode.type === "_output") {
            props.setPrvDisabled(false);
         } else {
            props.setPrvDisabled(true);
         }
         //executes when one of the previous nodes (other than max level) is selected or output node is selected (if one of them is already selected)
         const find = selectedNodes.find((data: any) => data.id === selNode.id);
         if (!find) {
            let nodesAfterDel: any = [];
            nodes.map((data: any) => {
               if (data.level < selNode.level) {
                  nodesAfterDel.push(data);
               } else if (data.level === selNode.level) {
                  nodesAfterDel.push({
                     id: data.id,
                     type: data.type,
                     data: data.data,
                     position: data.position,
                     level: data.level,
                     style: nodeStyle,
                  });
               }
               // data.level <= selNode.level && data.id !== selNode.id
            });

            let allEdges = edges;

            allEdges = allEdges.filter(
               (data: any) => data.targetLevel <= selNode.level
            );

            //  let edgeToRemoveStyleFrom = edgesAfterDel.filter((data:any)=> data.targetLevel)

            let nodeToRemoveFromSelNode = selectedNodes.find(
               (data: any) => data.level === selNode.level
            );

            if (nodeToRemoveFromSelNode) {
               const index = allEdges.findIndex(
                  (data: any) => data.target === nodeToRemoveFromSelNode.id
               );
               if (index >= 0) {
                  delete allEdges[index].style;
                  //  setEdges(allEdges);
               }
            }

            const indexOfEdgeToHighlight = allEdges.findIndex(
               (data: any) => data.target === selNode.id
            );
            if (indexOfEdgeToHighlight >= 0) {
               let highlightedEdge = allEdges[indexOfEdgeToHighlight];
               allEdges.splice(indexOfEdgeToHighlight, 1);
               highlightedEdge.style = selEdgeStyle;
               allEdges = [...allEdges, highlightedEdge];
               // setEdges(allEdges);
            }

            let selNodesAfterDel = selectedNodes.filter(
               (data: any) => data.level < selNode.level
            );

            setSelectedNodes(selNodesAfterDel);

            let selNodeInArray = nodes.find(
               (data: any) => data.id === selNode.id
            );
            selNodeInArray.style = selNodeStyle;

            const childrens = createChildren(selNode);
            setNodes([...nodesAfterDel, selNodeInArray, ...childrens.nodes]);
            setEdges([...allEdges, ...childrens.edges]);
         }
      }
   };

   return isLoading ? (
      <Backdrop
         sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
         open={isLoading}
         onClick={() => {
            setIsLoading(false);
         }}
      >
         <CircularProgress color="inherit" />
      </Backdrop>
   ) : (
      <ReactFlow
         nodes={nodes}
         edges={edges}
         onNodeClick={handleNodeClick}
         className="flowchart-canvas"
         nodesConnectable={false}
         nodeTypes={nodeTypes}
      >
         <Controls showFitView={true} showInteractive={false} />
         {/* <Background color="#aaa" gap={50   } /> */}
      </ReactFlow>
   );
};

export default Flowchart;
